import { Badge, BadgeProps, Text } from '@cmpsr/components';

type RiskAssessmentCompletedBadgeProps = {
  percentage: string;
} & BadgeProps;

export default function RiskAssessmentCompletedBadge({ percentage, ...props }: RiskAssessmentCompletedBadgeProps) {
  return (
    <Badge backgroundColor="secondary-default" w="max-content" px="4px" py="2px" {...props}>
      <Text color="text-light" variant="text-body-floating-label-bold">
        {percentage}
      </Text>
    </Badge>
  );
}
